import ApplicationsAccordion from 'components/ApplicationsAccordion';
import DetailsViewCardHeader from 'components/DetailsViewCardHeader';
import DetailsViewPageContainer from 'components/DetailsViewPageContainer';
import LinkedEntitiesAccordion from 'components/LinkedEntitiesAccordion';
import UpdateBatteryForm from 'components/forms/UpdateBatteryForm';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import { CARD_HEADER_DETAIL_TYPE, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const BatteryDetailsPage: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const {
        applications,
        currentBattery,
        dropdownMenuItems,
        entitiesLink,
        handleClose,
        handleEditClose,
        handleSelectApplication,
        handleToggleApplications,
        handleToggleLinkedEntities,
        isApplicationsLoading,
        isApplicationsOpen,
        isClosing,
        isEditing,
        isLinkedEntitiesOpen,
        isLoading,
        selectedApplicationId,
        selectedBoundaryGeometry,
        setIsClosing
    } = useData();

    const { APPLICATIONS, LINKED_ENTITIES } = useTranslation();

    return (
        <DetailsViewPageContainer
            geometry={selectedBoundaryGeometry}
            handleClose={handleClose}
            testId={testId}>
            <DetailsViewCardHeader
                detailType={CARD_HEADER_DETAIL_TYPE}
                isLoading={isLoading}
                items={dropdownMenuItems}
                name={currentBattery?.name ?? ''}
            />

            {isEditing ? (
                <UpdateBatteryForm
                    formValues={currentBattery}
                    isClosing={isClosing}
                    onClose={handleEditClose}
                    setIsClosing={setIsClosing}
                />
            ) : (
                <>
                    <LinkedEntitiesAccordion
                        entitiesLink={entitiesLink}
                        isOpen={isLinkedEntitiesOpen}
                        label={LINKED_ENTITIES}
                        onToggle={handleToggleLinkedEntities}
                    />

                    <ApplicationsAccordion
                        applications={applications}
                        isLoading={isApplicationsLoading}
                        isOpen={isApplicationsOpen}
                        label={APPLICATIONS}
                        onSelectApplication={handleSelectApplication}
                        onToggle={handleToggleApplications}
                        selectedApplicationId={selectedApplicationId}
                    />
                </>
            )}
        </DetailsViewPageContainer>
    );
};

export default BatteryDetailsPage;
